module.exports = __webpack_public_path__ + "img/new_castelatto_black.1bc6ef19.png";